import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import View from '@play-co/timestep-core/lib/ui/View';
import ImageScaleView from '@play-co/timestep-core/lib/ui/ImageScaleView';

export default class PopupMaintenance extends PopupBasic {
  constructor(opts: { superview: View; close: (result: boolean) => void }) {
    super({
      superview: opts.superview,
      close: () => opts.close(false),
      zIndex: 9999999,
      width: uiConfig.popups.minimumWidth,
      height: 480,
      darkerBg: true,
      tracking: { feature: 'maintenance', $subFeature: 'popup-maintenance' },
    });

    this.buttonClose.removeFromSuperview();

    new ImageScaleView({
      ...uiConfig.popups.scrollBox,
      superview: this.box,
      x: 30,
      y: 55,
      width: this.box.style.width - 60,
      height: 370,
    });

    this.message.updateOpts({
      width: this.box.style.width - 80,
      height: 370 - 40,
      verticalAlign: 'top',
      align: 'left',
      x: 40,
      y: 55 + 20,
      zIndex: 1,
    });
  }

  init() {
    super.init({ title: i18n('maintenance.title') });
    this.message.localeText = () => i18n('maintenance.message');
  }
}
